/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {pathToRegexp} from 'path-to-regexp';

export default class Route {
  constructor(path) {
    this.keys = [];
    this.regexp = pathToRegexp(path.replace(/\/$/, ''), this.keys);
  }

  getCallback(fn) {
    return (ctx, next) => {
      if (this.match(ctx.path, ctx.params)) {
        return fn(ctx, next);
      }
      return next();
    };
  }

  match(path, params) {
    let m = this.regexp.exec(path);
    if (!m) {
      return false;
    }

    for (let i = 1; i < m.length; i++) {
      let key = this.keys[i - 1];
      let val = m[i];

      if (val !== undefined) {
        params[key.name] = val;
      }
    }

    return true;
  }
}
